var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ele-text-center flex-row justify-center"},[_c('div',{staticClass:"ele-text-secondary"},[_vm._v(" "+_vm._s(_vm.$t('layout.footer.copyright'))+" ")]),_c('img',{staticStyle:{"margin-top":"2px","margin-left":"5px"},attrs:{"src":require("@/assets/footer-logo.png"),"height":"12"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }